(() => {
  if (customElements.get('balance-card-purchase')) return;
  // Serialize additions so the basket sections always reflect the latest addition.
  let additions = Promise.resolve();
  class CardPurchase extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('[data-card-purchase-form]');
      if (!this.form) return;
      this.quantity = this.form.querySelector('[name="quantity"]');
      this.variant = this.form.querySelector('[name="id"]');
      this.submit = this.form.querySelector('[type="submit"]');
      this.status = this.form.querySelector('[data-card-purchase-status]');
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.busy || !this.form.reportValidity()) return;
        const body = new FormData(this.form);
        if (!body.get('selling_plan')) body.delete('selling_plan');
        this.setBusy(true);
        this.status.textContent = '';
        delete this.status.dataset.error;
        additions = additions.catch(() => {}).then(() => this.add(body));
      });
      this.querySelectorAll('[data-card-quantity]').forEach(button => button.addEventListener('click', () => {
        if (this.busy) return;
        const {min, max, step} = this.limits();
        const current = Number(this.quantity.value);
        const value = Number.isFinite(current) && current >= min ? current : min;
        const aligned = min + Math.round((value - min) / step) * step;
        this.quantity.value = Math.max(min, Math.min(max, aligned + (button.dataset.cardQuantity === 'plus' ? step : -step)));
        this.syncButtons();
        this.quantity.dispatchEvent(new Event('change', {bubbles:true}));
      }));
      this.quantity.addEventListener('input', () => this.syncButtons());
      this.quantity.addEventListener('change', () => this.syncButtons());
      this.variant.addEventListener('change', () => {
        const option = this.variant.selectedOptions?.[0];
        if (!option?.value) return;
        this.quantity.min = option.dataset.min || '1';
        this.quantity.step = option.dataset.step || '1';
        if (option.dataset.max) this.quantity.max = option.dataset.max;
        else this.quantity.removeAttribute('max');
        this.quantity.value = this.quantity.min;
        this.syncPlans();
        this.status.textContent = '';
        this.syncButtons();
      });
      this.syncPlans();
      this.syncButtons();
    }
    syncPlans() {
      const select = this.form.querySelector('[data-balance-plan]');
      if (!select) return;
      const previous = select.value;
      select.querySelectorAll('[data-plan-variant]').forEach(option => {
        const match = option.dataset.planVariant === this.variant.value;
        option.hidden = !match;
        option.disabled = !match;
      });
      const available = Array.from(select.options).filter(option => !option.disabled);
      const chosen = available.find(option => option.value === previous) || available[0];
      if (chosen) chosen.selected = true;
    }
    limits() {
      return {min:Number(this.quantity.min)||1, step:Number(this.quantity.step)||1, max:this.quantity.max ? Number(this.quantity.max) : Infinity};
    }
    syncButtons() {
      const {min,max} = this.limits();
      const value = Number(this.quantity.value);
      this.querySelector('[data-card-quantity="minus"]').disabled = this.busy || value <= min;
      this.querySelector('[data-card-quantity="plus"]').disabled = this.busy || value >= max;
    }
    setBusy(busy) {
      this.busy = busy;
      this.submit.disabled = busy;
      this.submit.textContent = busy ? this.submit.dataset.addingLabel : this.submit.dataset.addLabel;
      this.quantity.disabled = busy;
      this.variant.disabled = busy;
      const plan = this.form.querySelector('[data-balance-plan]');
      if (plan) plan.disabled = busy;
      this.form.setAttribute('aria-busy', String(busy));
      this.syncButtons();
    }
    async add(body) {
      const drawer = document.querySelector('cart-drawer');
      body.append('sections', drawer ? 'cart-icon-bubble,cart-drawer' : 'cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
      let added = false;
      try {
        const response = await fetch(this.form.action + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.status.dataset.errorMessage);
        added = true;
        this.status.textContent = this.status.dataset.success.replace('[quantity]', body.get('quantity'));
        // Refresh the basket without opening it or interrupting shopping.
        const parser = new DOMParser();
        const bubble = document.getElementById('cart-icon-bubble');
        const bubbleHTML = data.sections?.['cart-icon-bubble'];
        if (bubble && bubbleHTML) {
          const fresh = parser.parseFromString(bubbleHTML, 'text/html').querySelector('.shopify-section');
          if (fresh) bubble.innerHTML = fresh.innerHTML;
        }
        const drawerHTML = data.sections?.['cart-drawer'];
        if (drawer && drawerHTML) {
          const fresh = parser.parseFromString(drawerHTML, 'text/html').querySelector('#CartDrawer');
          const current = drawer.querySelector('#CartDrawer');
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            drawer.classList.remove('is-empty');
            drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
          }
        }
        document.dispatchEvent(new CustomEvent('balance:basket-updated', {detail:{variantId:body.get('id'),quantity:Number(body.get('quantity'))}}));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {source:'balance-card-purchase',productVariantId:body.get('id'),cartData:data})).catch(() => {});
        }
      } catch (error) {
        // A rendering failure after a successful addition must not invite a duplicate order.
        if (!added) {
          this.status.dataset.error = 'true';
          this.status.textContent = this.status.dataset.errorMessage;
          if (error.message && error.message !== 'Failed to fetch' && error.message !== 'NetworkError when attempting to fetch resource.') this.status.textContent = error.message;
        }
      } finally {
        this.setBusy(false);
      }
    }
  }

  customElements.define('balance-card-purchase', CardPurchase);
})();
